import { ApprovalConsiderationAnnounceEightContainer } from '../../../containers/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceEightContainer';

export function ApprovalConsiderationAnnounceEightPage() {
    return (
        <ApprovalConsiderationAnnounceEightContainer />
    )
}